import Core from "../core";
import { AxiosError, AxiosResponse } from "axios";

async function getallEmpData(company_id: number, full_path: string, row?: number, page?: number, check?: any, isDept?: number, searchName?: string) {
  const api = Core.getInstance().api();
  const params: any = {
    companyId: company_id,
    locale: localStorage.getItem("emplang"),
    full_path: full_path,
    rowsPerPage: row,
    page: page,
    check: check,
    isDept: isDept,
    searchName: searchName,
    all: 1
  }
  const query = Object.entries(params)
    .filter(([key, value]) => value !== undefined && value !== null)
    .map(([key, value]: any) => `${key}=${encodeURIComponent(value)}`)
    .join("&");
  const data = await api.get(
    `/v1/getNotExitedCompanyEmployees?${query}`
  );

  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}

async function editAccess(id: number, checked: any) {
  const api = Core.getInstance().api();
  const pass = {
    user_id: id,
    is_active: checked
  }
  const data = await api.post(`/v1/employee/setStatus`, pass);
  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}

async function getDepartmentList(company_id: number) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/department/select?companyId=${company_id}&locale=${localStorage.getItem(
      "emplang"
    )}`
  );

  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}

export const employeeDirectoryService = {
  getallEmpData,
  getDepartmentList,
  editAccess
};
